import React from 'react';
import { Link } from 'react-router-dom';
import { getLocalized } from '../../store';

const toStr = (val, lang = 'en') => {
  if (val === null || val === undefined) return '';
  if (typeof val === 'string' || typeof val === 'number') return String(val);
  if (Array.isArray(val)) return val.map((v) => toStr(v, lang)).filter(Boolean).join(', ');
  if (typeof val === 'object') {
    if (val[lang]) return toStr(val[lang], lang);
    if (val.en) return toStr(val.en, lang);
    if (val.ru) return toStr(val.ru, lang);
    if (val.nl) return toStr(val.nl, lang);
    if (val.ro) return toStr(val.ro, lang);
    const first = Object.values(val).find((v) => typeof v === 'string');
    return first ? String(first) : '';
  }
  return String(val);
};

export const RelatedProducts = ({ products = [], language = 'en', categoryLabels = {}, title = 'Related Products' }) => {
  if (!Array.isArray(products) || products.length === 0) return null;

  const titleStr = toStr(title, language) || 'Related Products';

  return (
    <div className="mt-24 text-left font-light select-none">
      <h2 className="text-h2 mb-8">{titleStr}</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {products.slice(0, 4).map((p, index) => {
          const itemKey = p?.id || p?._id || index;
          const nameStr = toStr(getLocalized(p?.name, language) || p?.name, language) || 'Product';
          const catKey = toStr(p?.category, language);
          const catLabelStr = toStr(categoryLabels?.[catKey], language) || catKey;

          const imgUrl = typeof p?.images?.[0]?.url === 'string' 
            ? p.images[0].url 
            : (typeof p?.images?.[0] === 'string' ? p.images[0] : (p?.image || ''));

          return (
            <Link
              key={itemKey}
              to={`/${language}/products/${itemKey}`}
              className="group block select-none"
              data-testid={`related-${itemKey}`}
            >
              <div className="aspect-[3/4] overflow-hidden bg-muted mb-4 relative">
                {imgUrl ? (
                  <img
                    src={imgUrl}
                    alt={nameStr}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none select-none"
                    loading="lazy"
                    draggable={false}
                  />
                ) : (
                  <div className="w-full h-full bg-neutral-200" />
                )}
              </div>
              <h3 className="font-light text-lg mb-1 group-hover:underline underline-offset-4">
                {nameStr}
              </h3>
              {catLabelStr && <p className="text-sm text-muted-foreground">{catLabelStr}</p>}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedProducts;
